var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"modal-backdrop"}),_c('div',{staticClass:"modal"},[_c('div',{staticClass:"pull-right"},[_c('div',{staticClass:"btn-close",on:{"click":_vm.close}})]),_c('div',{staticClass:"tab"},[_c('iframe',{attrs:{"srcdoc":_vm.modifiedHtml}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }